(function (algolia, $, _, Shopify) {
  if (algolia.config.powered_by) console.log("You're using Algolia !\n" + "Visit https://www.algolia.com/ for more insight about what we do.");
  algolia.$ = algolia.jQuery = $.noConflict(true);
  algolia._ = algolia.underscore = algolia.lodash = _.noConflict();
  algolia.storeName = window.location.hostname.replace(/^www\./, "").replace(/^([^.]*)\..*$/, "$1");
  algolia.client = algoliasearch(algolia.config.app_id, algolia.config.search_api_key);
  algolia.templates = {};
  algolia.indices = {};
  algolia.full_results = window.location.href.match(/\/search/);
  algolia.is_collection_results_page = !!window.location.pathname.match(/^\/collections\/(?!all$)([^/]+)[/]*$/);
  algolia.hoganOptions = { delimiters: "[[ ]]" };
  algolia.getTemplate = function getTemplate(name) {
    return document.getElementById("template_algolia_" + name).innerHTML;
  };
  algolia.compileTemplate = function compileHoganTemplate(name) {
    return Hogan.compile(algolia.getTemplate(name), algolia.hoganOptions);
  };
  algolia.render = function render(template, obj) {
    obj = _.assign({}, obj, { helpers: algolia.hoganHelpers });
    return template.render(obj);
  };
  algolia.appendStyle = function appendStyle(content) {
    function insertAfter(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    var scripts = document.getElementsByTagName("script");
    var currentScript = scripts[scripts.length - 1];
    var style = document.createElement("style");
    style.innerHTML = content;
    insertAfter(style, currentScript);
  };
  algolia.money_format = algolia.getTemplate("money_format").replace(/^\s+|\s+$/g, "");
  algolia.formatMoney = function formatMoney(cents) {
    var val = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var format = algolia.money_format;
    var regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
    if (format.match(regexp)) return format.replace(regexp, "$1" + val + "$2");
    regexp = /^([^{}]*)\{\{amount_with_comma_separator\}\}([^{}]*)$/;
    if (format.match(regexp)) {
      var money = val.replace(/[.]/, "|");
      money = money.replace(/[,]/, ".");
      money = money.replace(/[|]/, ",");
      return format.replace(regexp, "$1" + money + "$2");
    }
    if (!_.isUndefined(Shopify) && !_.isUndefined(Shopify.formatMoney)) return Shopify.formatMoney(cents, format);
    return "$" + val;
  };
})(algoliaShopify, $, _, Shopify);(function(algolia){var enabled=algolia.config.analytics_enabled;if(!enabled)return;!function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e.aa=e.aa||function(){(e.aa.queue=e.aa.queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],i.async=1,i.src="https://cdn.jsdelivr.net/npm/search-insights@0.0.14",c.parentNode.insertBefore(i,c)}(window,document,"script",0,"aa");aa("init",{applicationID:algolia.config.app_id,apiKey:algolia.config.search_api_key});algolia.clickTracker=function(e){window.aa("click",{objectID:e.target.getAttribute("data-algolia-objectid"),position:parseInt(e.target.getAttribute("data-algolia-position")),queryID:e.target.getAttribute("data-algolia-queryid")})}})(algoliaShopify);(function(algolia){algolia.translations={search:"Current search",noCollectionFound:"No collection found",allProducts:"See all products",matching:"matching",sortBy:"Sort by",relevance:"Relevance",outOf:"out of",resultsFound:"results found",oneResultFound:"1 result found",noResultFound:"No result found",addToCart:"Add to cart",searchForProduct:"Search for products",selectedFilter:"Selected filters",clearAll:"Clear all",noPageFound:"No page found",outOfStock:"Out of stock"};algolia.translation_helpers={no_result_for:function(text,render){return"No result for query "+render(text)+""},"in":function(text,render){return"in "+render(text)+"s"},try_clear_or_change_input:function(text,render){var regex=new RegExp(/<\/a>|<a[a-z "-=]*>/,"g");var html_tags=text.match(regex);return"Try "+render(html_tags[0])+" clearing filters "+render(html_tags[1])+" or "+render(html_tags[2])+" changing your input "+render(html_tags[3])+""},outOf:function(text,render){return""+render(text)+" out of"},by:function(text,render){return"by "+render(text)+""}}})(algoliaShopify);(function(algolia){var _=algolia._;var formatPrice=function formatPrice(value){return algolia.formatMoney(+value*100)};function formattedPriceWithComparison(price,compare_at_price,price_ratio){var comparing=+compare_at_price&&+compare_at_price>+price,discount_ratio=1-price_ratio,res="<b>"+formatPrice(price)+"</b>";if(comparing){res+=' <span class="ais-hit--price-striked"><span>'+formatPrice(compare_at_price)+"</span></span> ";res+=' <span class="ais-hit--price-discount" style="font-weight: '+Math.floor(discount_ratio*10)*100+';">-'+Math.floor(discount_ratio*100)+"%</span>"}return res}var escapeHtml=function escapeHtml(unsafe){return(unsafe||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;")};algolia.helpers={formatNumber:function formatNumber(text,render){return Number(render(text)).toLocaleString()},formattedPrice:function formattedPrice(text,render){return formatPrice(render(text))},formattedPriceWithoutDecimals:function formattedPriceWithoutDecimals(text,render){return formatPrice(render(text)).replace(/\.\d+$/,"")},autocompletePrice:function autocompletePrice(text,render){if(this._distinct){var min=this.variants_min_price;var max=this.variants_max_price;if(min!==max)return"<b>"+formatPrice(min)+" - "+formatPrice(max)+"</b>"}return formattedPriceWithComparison(this.price,null)},instantsearchPrice:function instantsearchPrice(text,render){if(this._distinct){var min=this.variants_min_price;var max=this.variants_max_price;if(min!==max)return"<b>"+formatPrice(min)+" - "+formatPrice(max)+"</b>"}return formattedPriceWithComparison(this.price,this.compare_at_price,this.price_ratio)},instantsearchLink:function instantsearchLink(){var addVariantId=!this._distinct&&this.objectID!==this.id;return"/products/"+this.handle+(addVariantId?"?variant="+this.objectID:"")},fullTitle:function fullTitle(){var res=this.title;if(!this._distinct&&this.variant_title&&this.variant_title!=="Default Title"&&this.variant_title!=="Default")res+=" ("+this.variant_title+")";return escapeHtml(res)},fullHTMLTitle:function fullHTMLTitle(){var res=this._highlightResult.title.value;if(!this._distinct&&this.variant_title&&this.variant_title!=="Default Title"&&this.variant_title!=="Default")res+=' <span class="algolia-variant">('+this._highlightResult.variant_title.value+")</span>";return res},floor:function floor(text,render){return""+Math.floor(+render(text))},ceil:function ceil(text,render){return""+Math.ceil(+render(text))},sizedImage:function sizedImage(text,render){var image=this._distinct?this.product_image:this.image;if(!image)return"http://cdn.shopify.com/s/images/admin/no-image-compact.gif";var size=render(text).replace(/^\s+|\s+$/g,"");if(size==="original")return image;return image.replace(/\/(.*)\.(\w{2,4})/g,"/$1_"+size+".$2")}};_.forEach(["pico","icon","thumb","small","compact","medium","large","grande","original"],function(size){algolia.helpers[size+"Image"]=function(_size){return function(){var image=this._distinct?this.product_image:this.image;if(!image)return"http://cdn.shopify.com/s/images/admin/no-image-compact.gif";if(_size==="original")return image;return image.replace(/\/(.*)\.(\w{2,4})/g,"/$1_"+_size+".$2")}}(size)});algolia.hoganHelpers=_.reduce(Object.assign({},algolia.helpers,algolia.translation_helpers),function(res,helper,name){res[name]=function(){return function(text){var render=function(value){return Hogan.compile(value,algolia.hoganOptions).render(this)}.bind(this);return helper.call(this,text,render)}.bind(this)};return res},{})})(algoliaShopify);(function (algolia) {
  if (!algolia.config.autocomplete_enabled) return;
  var _ = algolia._,
    $ = algolia.jQuery;
  var autocomplete;
  function index(name) {
    return algolia.client.initIndex("" + algolia.config.index_prefix + name);
  }
  function addPositionToHits(hits, queryID) {
    return hits.map(function (entry, index) {
      entry._position = index + 1;
      entry._queryID = queryID;
      return entry;
    });
  }
  function autocompleteSection(section) {
    var params = autocomplete[section];
    if (params.enabled !== true) return null;
    var templates = {
      empty: function displayEmptyResultSet(props) {
        return algolia.render(params.templates.empty, Object.assign({}, props, { translations: algolia.translations }));
      },
      suggestion: function displaySuggestion(hit) {
        return algolia.render(params.templates.hit, Object.assign({ _distinct: params.distinct }, hit, { translations: algolia.translations }));
      },
    };
    if (params.templates.footer)
      templates.footer = function displayFooter(props, content) {
        if (content.nbHits <= params.hitsPerPage) return null;
        if (!autocomplete.showFooter) return null;
        return algolia.render(params.templates.footer, { query: props.query, nbHits: content.nbHits, translations: algolia.translations, helpers: algolia.helpers });
      };
    return {
      name: section,
      source: function (query, callback) {
        var searchOpts = {clickAnalytics: true, hitsPerPage: params.hitsPerPage, highlightPreTag: '<span class="aa-highlight">', highlightPostTag: "</span>" };
        if (section === 'products') {
          searchOpts.filters = 'tags:"Active"';
        }
        console.log('gsjgsjgkl',section);
        if (params.distinct) searchOpts.distinct = true;
        index(section)
          .search(query, searchOpts)
          .then(function (answer) {
            console.log('answer', answer);
            var hits = addPositionToHits(answer.hits, answer.queryID);
            callback(hits, answer);
          });
      },
      displayKey: "title",
      templates: templates,
    };
  }
  function readjust($this) {
    var data = $this.data("aaAutocomplete");
    if (!data) return;
    var $node = data.$node;
    var $dropdown = data.dropdown.$menu;
    var width = $this.outerWidth();
    var vpWidth = document.body.clientWidth;
    var offset = $this.offset();
    var left = offset.left;
    var right = vpWidth - width - left;
    var top = offset.top;
    var height = $this.outerHeight();
    var align = left < right ? "left" : "right";
    var dist = Math.min(left, right);
    if (4 * dist > vpWidth) {
      align = "left";
      dist = Math.round(vpWidth / 4);
    }
    var newWidth = vpWidth - 2 * dist;
    if (width >= 600) {
      align = "left";
      dist = left;
      newWidth = width;
    }
    $node
      .css("left", "")
      .css("right", "")
      .css("top", top + height + 8 + "px")
      .css(align, dist)
      .css("width", "" + newWidth + "px");
    var suffix = "lg";
    if (newWidth < 300) suffix = "xs";
    else if (newWidth < 600) suffix = "sm";
    else if (newWidth < 900) suffix = "md";
    $dropdown
      .removeClass("aa-dropdown-menu-size-xs")
      .removeClass("aa-dropdown-menu-size-sm")
      .removeClass("aa-dropdown-menu-size-md")
      .removeClass("aa-dropdown-menu-size-lg")
      .addClass("aa-dropdown-menu-size-" + suffix);
  }
  autocomplete = algolia.autocomplete = {
    articles: {
      enabled: algolia.config.index_articles,
      hitsPerPage: algolia.config.articles_autocomplete_hits_per_page,
      index: index("articles"),
      templates: { empty: algolia.compileTemplate("autocomplete_articles_empty"), hit: algolia.compileTemplate("autocomplete_article") },
    },
    pages: {
      enabled: algolia.config.index_pages,
      hitsPerPage: algolia.config.pages_autocomplete_hits_per_page,
      index: index("pages"),
      templates: { empty: algolia.compileTemplate("autocomplete_pages_empty"), hit: algolia.compileTemplate("autocomplete_page") },
    },
    collections: {
      enabled: algolia.config.index_collections,
      hitsPerPage: algolia.config.collections_autocomplete_hits_per_page,
      index: index("collections"),
      templates: { empty: algolia.compileTemplate("autocomplete_collections_empty"), hit: algolia.compileTemplate("autocomplete_collection") },
    },
    colors: algolia.config.colors,
    debug: algolia.config.autocomplete_debug,
    poweredBy: algolia.config.powered_by,
    products: {
      enabled: algolia.config.index_products,
      distinct: algolia.config.show_products,
      hitsPerPage: algolia.config.products_autocomplete_hits_per_page,
      index: index("products"),
      templates: { empty: algolia.compileTemplate("autocomplete_products_empty"), footer: algolia.compileTemplate("autocomplete_footer"), hit: algolia.compileTemplate("autocomplete_product") },
    },
    selector: algolia.config.input_selector + ", .algolia-shopify-autocomplete",
    showFooter: algolia.config.instant_search_enabled,
    storeName: algolia.storeName,
    templates: { dropdown: algolia.compileTemplate("autocomplete"), empty: "<div></div>", style: algolia.compileTemplate("autocomplete.css") },
  };
  if (autocomplete.poweredBy) console.log("Algolia: Autocomplete");
  algolia.appendStyle(algolia.render(autocomplete.templates.style, { colors: autocomplete.colors }));
  $(document).ready(function mainAutocomplete() {
    autocomplete.$input = $(autocomplete.selector);
    autocomplete.$input.autocomplete(
      {
        debug: autocomplete.debug,
        hint: false,
        appendTo: "body",
        templates: {
          dropdownMenu: algolia.render(autocomplete.templates.dropdown, {
            storeName: autocomplete.storeName,
            with: {
              articles: autocomplete.articles.enabled,
              collections: autocomplete.collections.enabled,
              pages: true,
              footer: autocomplete.showFooter,
              poweredBy: autocomplete.poweredBy,
              products: autocomplete.products.enabled,
            },
          }),
          empty: autocomplete.templates.empty,
        },
      },
      _.compact([autocompleteSection("collections"), autocompleteSection("articles"), autocompleteSection("pages"), autocompleteSection("products")])
    );
    autocomplete.$input.each(function () {
      var data = $(this).data("aaAutocomplete");
      console.log('auto input data',data);
      var dropdown = data.dropdown;
      var suggestionClass = "." + dropdown.cssClasses.prefix + "-" + dropdown.cssClasses.suggestion;
      var onSuggestionClick = dropdown._onSuggestionClick.bind(dropdown);
      var touchmoved;
      dropdown.$menu
        .on("touchend", suggestionClass, function (e) {
          if (touchmoved === false) {
            e.preventDefault();
            e.stopPropagation();
            onSuggestionClick.apply(this, arguments);
          }
        })
        .on("touchmove", function () {
          touchmoved = true;
        })
        .on("touchstart", function () {
          touchmoved = false;
        });
    });
    console.log('autocomplete.$input', autocomplete.$input);
    autocomplete.$input.on("autocomplete:selected", function (obj, datum, name) {
      if (algolia.config.analytics_enabled) window.aa("click", { objectID: datum.objectID, position: datum._position, queryID: datum._queryID });
      if (name === "products") {
        var addVariantId = !autocomplete.products.distinct && datum.objectID !== datum.id;
        window.location.href = "/" + name + "/" + datum.handle + (addVariantId ? "?variant=" + datum.objectID : "");
      } else if (name === "articles") window.location.href = "/blogs/" + datum.blog.handle + "/" + datum.handle;
      else window.location.href = "/" + name + "/" + datum.handle;
    });
    autocomplete.$input.on("autocomplete:redrawn", function () {
      readjust($(this));
    });
    $(window).resize(function () {
      autocomplete.$input.each(function () {
        readjust($(this));
      });
    });
  });
})(algoliaShopify);(function(algolia){var _=algolia._;var TYPES_TO_WIDGET={slider:{name:"rangeSlider",useDefault:true},menu:{name:"menu",params:{limit:10}},conjunctive:{name:"refinementList",params:{operator:"and",limit:10}},disjunctive:{name:"refinementList",params:{operator:"or",limit:10}}};var sortByRefined=function sortByRefined(sortFunction){return function(a,b){if(a.refined!==b.refined){if(a.refined)return-1;if(b.refined)return 1}return sortFunction(a,b)}};algolia.facetSortFunctions={price_range:sortByRefined(function sortRanges(a,b){if(a.name.length===b.name.length)return a.name.localeCompare(b.name);return a.name.length-b.name.length})};algolia.facetDisplayFunctions={price_range:function displayRange(value){var values=value.split(":");return _.map(values,function(e){return algolia.formatMoney(+e*100).replace(/\.\d+/,"")}).join(" - ")}};algolia.facetCssClasses={root:"ais-facet",header:"ais-facet--header",body:"ais-facet--body",item:"ais-facet--item",label:"ais-facet--label",checkbox:"ais-facet--checkbox",active:"ais-facet--active",count:"ais-facet--count"};var enabledFacets=_.filter(algolia.config.facets,function(facet){return facet.enabled||parseInt(facet.enabled)});algolia.facets=_.map(enabledFacets,function(facet){return Object.assign({},facet,{escapedName:encodeURIComponent(facet.name)})});algolia.shownFacets=_.filter(algolia.facets,function(facet){return facet.type!=="hidden"});algolia.hiddenFacets=_.filter(algolia.config.facets,function(facet){return facet.type==="hidden"});algolia.facetTitles={};_.each(algolia.facets,function(facet){algolia.facetTitles[facet.name]=facet.title});algolia.facetsWidgets=_.map(algolia.shownFacets,function(facet){var widget=TYPES_TO_WIDGET[facet.type],params=_.cloneDeep(widget.params)||{};params.container="[class~='ais-facet-"+facet.escapedName+"']";params.attributeName=facet.name;params.templates={};params.cssClasses=algolia.facetCssClasses;if(facet.searchable){params.searchForFacetValues={placeholder:"Search for "+facet.name,isAlwaysActive:true};params.searchForFacetValues.templates={noResults:"<div> No matching "+facet.name+"</div>"}}params.templates.header=function(){return facet.title};if(!widget.useDefault)params.templates.item=algolia.getTemplate("instant_search_facet_item");if(algolia.facetSortFunctions[facet.name])params.sortBy=algolia.facetSortFunctions[facet.name];var displayFunction=algolia.facetDisplayFunctions[facet.name];params.transformData=function(data){data.type={};data.type[facet.type]=true;if(displayFunction)data.name=displayFunction(data.name);return data};return{name:widget.name,params:params}})})(algoliaShopify);(function(algolia){var _=algolia._;var sort_order_base=""+algolia.config.index_prefix+"products";algolia.sortOrders=[{name:sort_order_base,label:""+algolia.translations.relevance}];_.forEach(algolia.config.sort_orders,function(sort_order){if(!_.isUndefined(sort_order.asc)&&!_.isNull(sort_order.asc)&&(sort_order.asc.active===true||sort_order.asc.active==="1"))algolia.sortOrders.push({name:sort_order_base+"_"+sort_order.key+"_asc",label:sort_order.asc.title});if(!_.isUndefined(sort_order.desc)&&!_.isNull(sort_order.desc)&&(sort_order.desc.active===true||sort_order.desc.active==="1"))algolia.sortOrders.push({name:sort_order_base+"_"+sort_order.key+"_desc",label:sort_order.desc.title})})})(algoliaShopify);(function (algolia, instantsearch) {
  var collectionFacetConstraint = !!algolia.is_collection_results_page && !!algolia.config.instant_search_enabled_on_collection;
  if ((!algolia.full_results && !collectionFacetConstraint) || !algolia.config.instant_search_enabled) return;
  var _ = algolia._,
    $ = algolia.jQuery;
  var collectionFacetValue = null;
  if (collectionFacetConstraint) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    if (!!matches && matches.length === 2) collectionFacetValue = matches[1];
  }
  algolia.config.results_selector += ", .algolia-shopify-instantsearch";
  var $hiding = $("<style>" + algolia.config.results_selector + " { visibility: hidden }</style>");
  $hiding.appendTo($("head"));
  var instant = (algolia.instantsearch = {
    colors: algolia.config.colors,
    distinct: !!algolia.config.show_products,
    facets: { hidden: algolia.hiddenFacets, shown: algolia.shownFacets, list: algolia.facets, widgets: algolia.facetsWidgets },
    hitsPerPage: algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      indexName: "" + algolia.config.index_prefix + "products",
      searchParameters: { clickAnalytics: true },
      urlSync: {},
      searchFunction: function (searchFunctionHelper) {
        var helper = instant.search.helper;
        var page = helper.getPage();
        helper.setQueryParameter("highlightPreTag", '<span class="ais-highlight">');
        helper.setQueryParameter("highlightPostTag", "</span>");
        if (instant.distinct) helper.setQueryParameter("distinct", true);
        if (!!collectionFacetConstraint && !!collectionFacetValue) helper.setQueryParameter("filters", 'collections:"' + collectionFacetValue + '"');
        helper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: algolia.config.results_selector + ", .algolia-shopify-instantsearch",
    sortOrders: algolia.sortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate("instant_search_current_refined_values_item"),
      empty: algolia.getTemplate("instant_search_no_result"),
      page: algolia.compileTemplate("instant_search"),
      product: algolia.getTemplate("instant_search_product"),
      stats: algolia.getTemplate("instant_search_stats"),
      style: algolia.compileTemplate("instant_search.css"),
    },
  });
  if (instant.poweredBy) console.log("Algolia: Instant-Search");
  function readjust() {
    var width = instant.$results.outerWidth();
    var suffix = "lg";
    if (width < 400) suffix = "xs";
    else if (width < 800) suffix = "sm";
    else if (width < 1200) suffix = "md";
    instant.$results
      .removeClass("ais-results-size-xs")
      .removeClass("ais-results-size-sm")
      .removeClass("ais-results-size-md")
      .removeClass("ais-results-size-lg")
      .addClass("ais-results-size-" + suffix);
  }
  _.forEach(Object.assign({}, algolia.helpers, algolia.translation_helpers), function (helper, name) {
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;
  algolia.appendStyle(algolia.render(instant.templates.style, { distinct: instant.distinct, colors: instant.colors }));
  $(document).ready(function () {
    if ($(algoliaShopify.config.results_selector).length == 0) throw new Error("Instant search CSS selector is incorrect\nFore more info see : https://community.algolia.com/shopify/css_selector.html#algolia-search");
    instant.$results = $(instant.selector);
    instant.$results.html(algolia.render(instant.templates.page, { facets: instant.facets.list, storeName: instant.storeName, translations: algolia.translations }));
    readjust();
    $(window).resize(function () {
      readjust();
    });
    instant.search.addWidget({
      init: function (opts) {
        var $button = $(".ais-facets-button");
        $button.on("click", function () {
          var $facets = $(".ais-facets");
          if ($facets.hasClass("ais-facets__shown")) {
            $button.text("Show filters");
            $facets.removeClass("ais-facets__shown");
          } else {
            $button.text("Hide filters");
            $facets.addClass("ais-facets__shown");
          }
        });
      },
    });
    instant.search.addWidget(instantsearch.widgets.searchBox({ container: ".ais-search-box-container", placeholder: algolia.translations.searchForProduct, poweredBy: false }));
    instant.search.addWidget({
      init: function (opts) {
        if (!instant.poweredBy) $(".ais-algolia-icon").hide();
        $(".ais-clear-input-icon").on("click", function () {
          opts.helper.setQuery("").search();
          $(".ais-search-box--input").val("").focus();
        });
      },
      render: function (opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) $(".ais-algolia-icon").show();
          $(".ais-clear-input-icon").hide();
        } else {
          $(".ais-clear-input-icon").show();
          $(".ais-algolia-icon").hide();
        }
      },
    });
    instant.search.addWidget(
      instantsearch.widgets.stats({
        container: ".ais-stats-container",
        templates: { body: instant.templates.stats },
        transformData: {
          body: function (data) {
            data.processingTimeS = data.processingTimeMS / 1e3;
            data.start = data.page * data.hitsPerPage + 1;
            data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
            data.translations = algolia.translations;
            return data;
          },
        },
      })
    );
    instant.search.addWidget(instantsearch.widgets.sortBySelector({ container: ".ais-sort-orders-container", indices: instant.sortOrders }));
    instant.search.addWidget({
      init: function (opts) {
        $(".ais-search-header").on("click", ".ais-change-display-block", function () {
          $(".ais-change-display-block:not(.ais-change-display-selected)").addClass("ais-change-display-selected");
          $(".ais-change-display-list.ais-change-display-selected").removeClass("ais-change-display-selected");
          $(".ais-results-as-list").removeClass("ais-results-as-list").addClass("ais-results-as-block");
        });
        $(".ais-search-header").on("click", ".ais-change-display-list", function () {
          $(".ais-change-display-list:not(.ais-change-display-selected)").addClass("ais-change-display-selected");
          $(".ais-change-display-block.ais-change-display-selected").removeClass("ais-change-display-selected");
          $(".ais-results-as-block").removeClass("ais-results-as-block").addClass("ais-results-as-list");
        });
      },
    });
    var list = _.map(instant.facets.hidden, function (facet) {
      return facet.name;
    });
    instant.search.addWidget({
      getConfiguration: function () {
        return { facets: list, disjunctiveFacets: list };
      },
      init: function () {},
    });
    var attributes = _.map(instant.facets.shown, function (facet) {
      return { name: facet.name, label: facet.title };
    });
    instant.search.addWidget(
      instantsearch.widgets.currentRefinedValues({
        container: ".ais-current-refined-values-container",
        cssClasses: { root: "ais-facet", header: "ais-facet--header", body: "ais-facet--body" },
        templates: { header: algolia.translations.selectedFilter, item: instant.templates.currentItem, clearAll: algolia.translations.clearAll },
        onlyListedAttributes: true,
        attributes: attributes,
      })
    );
    _.forEach(instant.facets.widgets, function (widget) {
      instant.search.addWidget(instantsearch.widgets[widget.name](widget.params));
    });
    instant.search.addWidget(
      instantsearch.widgets.hits({
        container: ".ais-hits-container",
        hitsPerPage: instant.hitsPerPage,
        templates: { empty: instant.templates.empty, item: instant.templates.product },
        transformData: {
          item: function (product) {
            product._distinct = instant.distinct;
            product.can_order = product.inventory_management !== "shopify" || product.inventory_policy === "continue" || product.inventory_quantity > 0;
            product.translations = algolia.translations;
            product.queryID = instant.search.helper.lastResults._rawResults[0].queryID;
            product.productPosition = product.__hitIndex + 1;
            return product;
          },
          empty: function (params) {
            params.translations = algolia.translations;
            return params;
          },
        },
      })
    );
    instant.search.addWidget({
      init: function (opts) {
        $(".ais-hits-container").on("click", ".ais-hit", function (e) {
          var $this = $(this),
            handle = $this.attr("data-handle"),
            variant_id = $this.attr("data-variant-id");
          distinct = $this.attr("data-distinct");
          var link = "/products/" + handle;
          if (distinct !== "true") link += "?variant=" + variant_id;
          if (algolia.config.analytics_enabled) algolia.clickTracker(e);
          window.location.href = link;
        });
        $(".ais-hits-container").on("click", ".ais-hit a", function (e) {
          e.stopPropagation();
          if (algolia.config.analytics_enabled) algolia.clickTracker(e);
        });
      },
    });
    instant.search.addWidget({
      init: function (opts) {
        $(".ais-hits-container").on("click", ".ais-hit--cart-button", function (e) {
          e.stopPropagation();
          var $this = $(this),
            formId = $this.attr("data-form-id");
          if (formId) document.getElementById(formId).submit();
        });
      },
    });
    instant.search.addWidget({
      init: function (opts) {
        $(".ais-hits-container").on("click", ".ais-hit-empty--clear-filters", function () {
          var helper = opts.helper;
          helper.clearTags();
          _.forEach(instant.facets.list, function (facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });
        $(".ais-hits-container").on("click", ".ais-hit-empty--clear-input", function () {
          opts.helper.setQuery("").search();
          $(".ais-search-box--input").val("").focus();
        });
      },
    });
    instant.search.addWidget(instantsearch.widgets.pagination({ container: ".ais-pagination-container", padding: 2, maxPages: 20 }));
    instant.search.start();
    $hiding.remove();
  });
})(algoliaShopify, instantsearch);










